import { createRoutine } from 'redux-saga-routines';

export const fetchNotifications = createRoutine('FETCH_NOTIFICATIONS');
export const fetchUnseenCount = createRoutine('FETCH_UNSEEN_COUNT');
export const updateNotification = createRoutine('UPDATE_NOTIFICATION');
export const updateAllNotifications = createRoutine('UPDATE_ALL_NOTIFICATION');
export const hideAppBar = createRoutine('HIDE_APP_BAR');
export const showInfoMessage = createRoutine('SHOW_INFO_APP_BAR');
export const showWarningMessage = createRoutine('SHOW_WARNING_APP_BAR');

export const setNotificationDrawerVisibleStatus = createRoutine(
  'SET_NOTIFICATION_DRAWER_VISIBLE_STATUS'
);
export const saveNotificationPreferences = createRoutine(
  'SAVE_NOTIFICATION_PREFERENCES'
);
export const fetchNotificationPreferences = createRoutine(
  'FETCH_NOTIFICATION_PREFERENCES'
);
export const resetNotificationPreferences = createRoutine(
  'RESET_NOTIFICATION_PREFERENCES'
);
